import React from 'react';
import Tabs from './components/Tabs';

function App() {
  return (
    <div style={{ padding: '2rem' }}>
      <Tabs />
    </div>
  );
}

export default App;
